<ng-container *ngIf="desktop | async" >
  <div class="section_7">
    <div class="section_7-img">
      <img ngOptimizedImage [ngSrc]="'../assets/images/Death_to_stock_cycling_in_Seattle_6_large 1.webp'" [fill]="true" alt="">
    </div>
    <div class="section_7-content">
      <div>
        <div class="section-header">
          <ng-container i18n>We want to keep you traveling</ng-container>
        </div>
        <div class="section-content">
          <ng-container i18n>Hostel Hop was built by travelers who have lived and worked in hostels for more than a decade. We know what is important to serious backpackers, and we prioritize features that promote the lifestyle you seek.</ng-container>
        </div>
      </div>
      <div class="button-wrapper">
        <a class="btn btn-frame btn-large btn-icon sign-in-btn" (click)="login()" target="_blank">
          <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/backpack_2.svg"></svg-icon>
          <ng-container i18n>Sign up with Hostel Hop</ng-container>
        </a>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!(desktop | async)" >
  <div class="section_7-sm">
    <div class="section_7-img">
      <img ngOptimizedImage [ngSrc]="'../assets/images/Death_to_stock_cycling_in_Seattle_6_large 1.webp'" [fill]="true" alt="">
    </div>
    <div class="section_7-content">
      <div>
        <div class="section-header">
          <ng-container i18n>We want to keep you traveling</ng-container>
        </div>
        <div class="section-content">
          <ng-container i18n>Hostel Hop was built by travelers who have lived and worked in hostels for more than a decade. We know what is important to serious backpackers, and we prioritize features that promote the lifestyle you seek.</ng-container>
        </div>
      </div>
      <div class="button-wrapper">
        <a class="btn btn-frame btn-large btn-icon sign-in-btn" (click)="login()" target="_blank">
          <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/backpack_2.svg"></svg-icon>
          <ng-container i18n>Sign up with Hostel Hop</ng-container>
        </a>
      </div>
    </div>
  </div>
</ng-container>
